import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { LogoMark } from '@/components/generals/logo-mark'
import { siteConfig } from '@/constants/site'

interface WordmarkProps {
    className?: string
    onClick?: () => void
}

export const Wordmark: FC<WordmarkProps> = ({ className, onClick }): ReactNode => {
    return (
        <Link
            href='/#hero'
            onClick={onClick}
            className={cn(
                'group inline-flex items-center gap-3 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-4 focus-visible:ring-offset-background',
                className
            )}
        >
            <LogoMark animated />

            <span className='font-display text-[0.78rem] font-extrabold uppercase leading-none tracking-[0.06em] text-white sm:text-sm'>
                {siteConfig.name}
            </span>
        </Link>
    )
}
